<template>
    <div id="brush-tool-options"
         class="tool-options"
    >
        <brush-selector></brush-selector>
        <color-selector class="color-selector-container"></color-selector>
        <div class="opacity-wrapper">
            <div class="slider-container">
                <slider :width="'8px'"
                        :height="'100%'"
                        :min="0"
                        :max="100"
                        :step = "1"
                        :vertical="true"
                        :styleHandler="styleOpacitySlider"
                        :title="i18n.t('tooltip_transparency')"
                        id="slider-opacity"
                        ref="refOpacitySlider"
                        @slider-sliding="onOpacitySliderSliding"
                        @slider-slided="onOpacitySliderSlided"
                        @slider-slide-to="onSliderSlideTo"
                        @slider-ready="onSliderReady"
                        v-if=" toolState.activeTool === 'brush'"
                ></slider>
            </div>
            <div class="opacity-preview">
                <div id="opacity" :style="styleOpacity">

                </div>
            </div>
        </div>
        <size-selector></size-selector>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, nextTick, inject}  from "vue"
    import {useTool} from "@/modules/reader/tools/tools";
    import ColorSelector from "@/views/reader/tool/ColorSelector";
    import SizeSelector from "@/views/reader/tool/SizeSelector";
    import BrushSelector from "@/views/reader/tool/BrushSelector";
    import Slider from "@/views/lib/slider/Slider";
    import cssvar from '@/scss/_variables.scss';

    const colorPrimary = cssvar.colorPrimary;
    const borderColorLight = cssvar.borderColorLight;

     export default {
        components: {
            ColorSelector,
            SizeSelector,
            BrushSelector,
            Slider
        },
        setup(props, context) {

            const {toolState, TOOL_BRUSH} = useTool();
            const refOpacitySlider = ref(null);
            const i18n = inject('i18n');

            const styleOpacitySlider = {
                width: "40px",
                height: "22px",
                background: "#fcd549",
                color: "#000",
                fontSize: "13px",
                lineHeight: "13px",
                boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), 0 2px 2px rgba(0,0,0,0.3), 0 0 4px 1px rgba(0,0,0,0.2), inset 0 3px 2px rgba(255,255,255,.22), inset 0 -3px 2px rgba(0,0,0,.15), inset 0 20px 10px rgba(255,255,255,.12), 0 0 4px 1px rgba(0,0,0,.1), 0 3px 2px rgba(0,0,0,.2)",
                border: "1px solid rgba(0,0,0,0.15)",
                borderRadius: "10px"
            }

            const styleOpacity = computed(() => {
                return {
                    opacity: toolState.brushSetting.opacity,
                    background: toolState.brushSetting.color
                }
            });

            const onOpacitySliderSliding = (e) => {
                toolState.brushSetting.opacity = e / 100;
                refOpacitySlider.value.setLabel(`${Math.round(e)}%`);
            }

            const onOpacitySliderSlided = (e) => {

            }

            const onSliderSlideTo = (e) => {
                refOpacitySlider.value.setLabel(`${Math.round(e)}%`);
            }

            const onSliderReady = (e) => {
                refOpacitySlider.value.setValue(toolState.brushSetting.opacity * 100)
                refOpacitySlider.value.setLabel(`${Math.round(toolState.brushSetting.opacity * 100) }%`);
            }

            return {
                i18n,
                toolState,
                refOpacitySlider,
                onOpacitySliderSliding,
                onOpacitySliderSlided,
                onSliderSlideTo,
                onSliderReady,
                styleOpacitySlider,
                styleOpacity,
                TOOL_BRUSH
            }
        }
    }

</script>

<style scoped lang="scss">

    #brush-tool-options {
        width:380px;
        height:258px;
        display:flex;
    }

    .opacity-wrapper {
        height:228px;
        align-self:center;
        @include tool-seperator(right);
    }

    .slider-container {
        width:100%;
        height:160px;
        margin: 14px 8px;
    }

    .color-selector-container {
        @include tool-seperator(left);
        @include tool-seperator(right);
    }

    .opacity-preview {

        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 0 0;

        #opacity {
            width: 26px;
            height: 26px;
            border-radius:26px;
        }
    }

</style>